import { useMemo } from 'react';

export interface WhtLineState {
  enabled: boolean;
  incomeType: string;
  rate: number;
}

// Exported so the cross-vendor PaymentRunWizard (B2) shares one income-type
// source. The server (WhtService.resolveRate) remains authoritative — these
// rates drive the UI preview only.
export const WHT_TYPES: { code: string; labelTh: string; rate: number }[] = [
  { code: 'SVC', labelTh: 'ค่าบริการ/จ้างทำของ', rate: 3 },
  { code: 'PROF', labelTh: 'วิชาชีพอิสระ', rate: 3 },
  { code: 'RENT', labelTh: 'ค่าเช่า', rate: 5 },
  { code: 'ADS', labelTh: 'ค่าโฆษณา', rate: 2 },
  { code: 'XPORT', labelTh: 'ค่าขนส่ง', rate: 1 },
  { code: 'COMM', labelTh: 'ค่านายหน้า', rate: 3 },
  { code: 'PRIZE', labelTh: 'รางวัล/ส่วนลด', rate: 5 },
  { code: 'DIV', labelTh: 'เงินปันผล', rate: 10 },
  { code: 'INT', labelTh: 'ดอกเบี้ย', rate: 1 },
  { code: 'FOREIGN', labelTh: 'จ่ายต่างประเทศ', rate: 15 },
];

export function WhtLineEditor({
  subtotal,
  billId: _billId,
  value,
  onChange,
}: {
  subtotal: number;
  billId: string;
  value: WhtLineState;
  onChange: (v: WhtLineState) => void;
}) {
  const whtAmount = useMemo(
    () => (value.enabled ? Math.round(subtotal * value.rate) / 100 : 0),
    [value.enabled, value.rate, subtotal],
  );
  return (
    <div data-testid="wht-block" style={{ marginTop: 8 }}>
      <label style={{ display: 'flex', gap: 8, alignItems: 'center', fontSize: 14 }}>
        <input
          type="checkbox"
          aria-label="หักภาษี ณ ที่จ่าย"
          checked={value.enabled}
          onChange={(e) => onChange({ ...value, enabled: e.target.checked })}
        />
        หักภาษี ณ ที่จ่าย
      </label>
      {value.enabled && (
        <div style={{ display: 'flex', gap: 8, marginTop: 6, alignItems: 'center' }}>
          <select
            className="select"
            aria-label="ประเภทเงินได้"
            value={value.incomeType}
            onChange={(e) => {
              const t = WHT_TYPES.find((w) => w.code === e.target.value)!;
              onChange({ ...value, incomeType: t.code, rate: t.rate });
            }}
            style={{ height: 36, fontSize: 14 }}
          >
            {WHT_TYPES.map((t) => (
              <option key={t.code} value={t.code}>
                {t.labelTh} ({t.rate}%)
              </option>
            ))}
          </select>
          <span data-testid="wht-amount" className="tnum">
            -{whtAmount.toFixed(2)}
          </span>
        </div>
      )}
    </div>
  );
}
